module.exports = __webpack_public_path__ + "img/case-studies4.bee06afc.jpg";